import { SEO } from '@/components/SEO';
import { Hero } from '@/sections/Hero';
import { WhatIsMec } from '@/sections/WhatIsMec';
import { MiAdminShowcase } from '@/sections/MiAdminShowcase';
import { PackageJourney } from '@/sections/PackageJourney';
import { Coverage } from '@/sections/Coverage';
import { Partners } from '@/sections/Partners';
import { TransitariasTeaser } from '@/sections/TransitariasTeaser';
import { ConcursoBanner } from '@/sections/ConcursoBanner';
import { FinalCTA } from '@/sections/FinalCTA';
import { OurWork } from '@/sections/OurWork';
import { LatestPosts } from '@/sections/LatestPosts';
import { Footer } from '@/sections/Footer';

export function Home() {
  return (
    <main className="overflow-hidden">
      <SEO
        title="Software para Agencias de Envíos a Cuba | Mi Envío Cuba"
        description="Plataforma de software en la nube para agencias de envíos a Cuba y sus transitarias: panel web de gestión para tu equipo, app móvil para tus clientes y app de almacén y reparto que funciona sin señal — conectados en tiempo real."
        path="/"
        keywords="software para agencias de envíos a Cuba, plataforma gestión courier Cuba, app agencias paquetes Cuba, sistema para agencia de paquetería a Cuba, digitalizar agencia envíos Cuba, gestión courier Cuba, software para transitarias Cuba, rastreo de paquetes para agencias"
      />
      {/* PROMO (temporary): concurso banner — remove when the promo ends */}
      <ConcursoBanner />
      <Hero />
      <WhatIsMec />
      <MiAdminShowcase />
      <PackageJourney />
      <Coverage />
      <Partners />
      <TransitariasTeaser />
      <FinalCTA />
      <OurWork />
      <LatestPosts />
      <Footer />
    </main>
  );
}
